import * as React from 'react';

import { ITableConfig } from 'src/components/common/table';

import PagedResultSet from 'src/models/common/PagedResultSet';
import FormButton from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';

import Client from 'src/models/Client';
import DeleteConfirmDialog from '../DeleteConfirmDialog';
import { connect } from 'react-redux';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { ODataOptions } from 'src/util/ODataBuilder';

interface IClientsPageLocalProps {
    visibility: boolean;
    selectedClient: Client;
    deleteClientText: string;
}

interface IClientsPageStateProps {
    isLoading: boolean;
    clients: PagedResultSet<Client> | undefined;
    tableConfig: ITableConfig;
}
export interface IClientsPageDispatchProps {
    getClients: (options: ODataOptions) => void;
    navigate: (path: string) => void;
    initializePage: () => void;
    incrementPage: () => void;
    decrementPage: () => void;
    showDialog: (dialogname: string) => void;
    hideDialog: () => void;
    deleteClient: (clientNumber: number) => void;
}

type IClientPageProps = IClientsPageStateProps & IClientsPageDispatchProps;

class AdminClientsPage extends React.Component<IClientPageProps, IClientsPageLocalProps> {
    constructor(props: IClientPageProps) {
        super(props);
        this.state = {
            visibility: false,
            deleteClientText: '',
            selectedClient: undefined,
        };
    }

    public componentDidMount() {
        this.props.initializePage();
        this.props.getClients(new ODataOptions());
    }

    rowClick = (id: number | string) => {
        this.props.navigate(`/clients/${id}`);
    };

    addClientClick = () => {
        this.props.navigate(`/clients/add`);
    };

    editClient = (clientNumber: number) => {
        this.props.navigate(`/clients/edit-client/${clientNumber}`);
    };

    showDeleteDialog = (client: Client) => {
        this.setState({ selectedClient: client });
        this.props.showDialog(DialogList.DELETE_CLIENT);
    };

    deleteClient = (client: Client) => {
        if (client.cloakName === this.state.deleteClientText) {
            this.props.deleteClient(client.clientNumber);
            this.props.hideDialog();
            this.props.navigate(`/admin/clients`);
        }
    };

    updateText = (text: string) => {
        this.setState({ deleteClientText: text });
    };

    showShadow = (client: Client) => {
        this.setState({ visibility: true });
        client.isRealVisible = true;
        setTimeout(() => {
            this.hideShadow(client);
            this.setState({ visibility: false });
        }, 2000);
    };

    hideShadow = (client: Client) => {
        this.setState({ visibility: false });
        client.isRealVisible = false;
    };

    toggleShadow = (client: Client) => {
        if (client.isRealVisible) {
            this.hideShadow(client);
        } else {
            this.showShadow(client);
        }
    };

    displayExistingClients = () => {
        if (this.props.clients) {
            const multiplier = this.props.clients.pageNumber - 1;
            const startIndex = multiplier * this.props.clients.pageNumber;
            const endIndex = startIndex + this.props.clients.pageSize;
            return (
                <>
                    {this.props.clients.items &&
                        this.props.clients.items.slice(startIndex, endIndex).map((c: Client) => {
                            return (
                                <div key={c.id}>
                                    <div className="card-row">
                                        <div className="client-shadow-icon-width right-align">
                                            {c.isShadow && (
                                                <FormButton text="" className="margin-icon" onClick={() => this.toggleShadow(c)} icon="shadow" />
                                            )}
                                        </div>
                                        <div className="lh-card-row card" onClick={() => this.rowClick(c.clientNumber)}>
                                            <div className="lh-fifth-width">
                                                {c.isRealVisible && <>{c.name}</>}
                                                {!c.isRealVisible && <>{c.cloakName ? c.cloakName : c.name}</>}
                                            </div>
                                            <div className="lh-fifth-width client-address">
                                                {c.address && c.address.addressLine1 ? c.address.addressLine1 : undefined}
                                            </div>
                                            <div className="lh-fifth-width client-address">
                                                {c.address && c.address.city ? c.address.city : undefined}
                                            </div>
                                            <div className="lh-fifth-width client-address">
                                                {c.address && c.address.state && c.address.state.abbreviation
                                                    ? c.address.state.abbreviation
                                                    : undefined}
                                            </div>
                                        </div>
                                        <div className="client-shadow-icon-width left-align">
                                            <FormButton text="" className="margin-icon" onClick={() => this.showDeleteDialog(c)} icon="trash" />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    <DeleteConfirmDialog
                        title="Delete Client"
                        promptText="Type Client Name to confirm delete"
                        dialogName={DialogList.DELETE_CLIENT}
                        delete={this.deleteClient}
                        item={this.state.selectedClient}
                        updateText={this.updateText}
                    />
                </>
            );
        } else {
            return <div>No offices for project</div>;
        }
    };

    public render() {
        return (
            <>
                <div className="card-header client-card-header" />
                <div className="card-header-row">
                    <div className="client-shadow-icon-width" />
                    <div className="card-header-group">
                        <div className="lh-fifth-width">Name</div>
                        <div className="lh-fifth-width">Address</div>
                        <div className="lh-fifth-width">City</div>
                        <div className="lh-fifth-width">State</div>
                    </div>
                    <div className="client-shadow-icon-width" />
                </div>
                <div className="card-list scrollable">{this.displayExistingClients()}</div>
                <div className="bottom-button-row">
                    <div className="client-shadow-icon-width" />
                    <div className="bottom-button-group right-align">
                        <div className="pager-button-group">
                            {this.props.clients && this.props.clients.pageNumber > 1 && (
                                <FormButton text={'Prev ' + this.props.clients.pageSize} className="left-align" onClick={this.props.decrementPage} />
                            )}
                            {this.props.clients && this.props.clients.pageNumber * this.props.clients.pageSize < this.props.clients.totalRecords && (
                                <FormButton text={'Next ' + this.props.tableConfig.rowCount} onClick={this.props.incrementPage} />
                            )}
                        </div>
                    </div>
                    <div className="client-shadow-icon-width" />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoading: selectors.client.isLoadingClients(state),
    clients: selectors.client.clients(state),
    tableConfig: selectors.client.clientsPageTableConfig(state),
});

const mapDispatchToProps: IClientsPageDispatchProps = {
    getClients: (options: ODataOptions) => actions.client.getClients(options),
    navigate: (path: string) => push(path),
    incrementPage: () => actions.client.incrementClientPage(),
    decrementPage: () => actions.client.decrementClientPage(),
    initializePage: () => actions.client.initializeClientPage(),
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
    hideDialog: () => actions.layout.hideDialog(),
    deleteClient: (clientNumber: number) => actions.client.deleteClient(clientNumber),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminClientsPage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminClientsPage.tsx